import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import StoreContext from '../../providers/storesContext'
import TotalBox from './TotalBox'

const CaseDetailPrice = ({ total }) => {
  const { caseDetailStore } = useContext(StoreContext)
  const { immobilizationCase, selectedReleaseMethod } = caseDetailStore

  if (selectedReleaseMethod || immobilizationCase.isTowed) {
    return <TotalBox amount={total || 0} />
  }

  return <div className="font-bold">Please select a release method</div>
}

export default observer(CaseDetailPrice)
